import type { ISerialize } from '@/objects/ISerialize';

export class SignalrHeatPlanBackupItemSubscribeParameters implements ISerialize {
    public HeatPlanID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { HeatPlanID?: number }) {
        this.HeatPlanID = values.HeatPlanID ?? 0;
    }

    public serialize(): string {
        return '{' + `"HeatPlanID": ${JSON.stringify(this.HeatPlanID)}` + '}';
    }

    /**
     * Creates an instance of SignalrHeatPlanBackupItemSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { HeatPlanID?: number }): SignalrHeatPlanBackupItemSubscribeParameters {
        return new SignalrHeatPlanBackupItemSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrHeatPlanBackupItemSubscribeParameters {
        return new SignalrHeatPlanBackupItemSubscribeParameters({ HeatPlanID: json.HeatPlanID });
    }

    /**
     * Creates an instance of SignalrHeatPlanBackupItemSubscribeParameters from another instance of SignalrHeatPlanBackupItemSubscribeParameters.
     * @param other The SignalrHeatPlanBackupItemSubscribeParameters you want to clone
     * @returns A cloned SignalrHeatPlanBackupItemSubscribeParameters
     */
    public static FromOther(other: SignalrHeatPlanBackupItemSubscribeParameters): SignalrHeatPlanBackupItemSubscribeParameters {
        return SignalrHeatPlanBackupItemSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrHeatPlanBackupItemSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrHeatPlanBackupItemSubscribeParameters';
}
